import React, { useEffect, useState } from "react";
import Images from "../Images";
import tw from "tailwind-styled-components";
import Config from "../Config";
import axios from "axios";
import moment from "moment";
import { useDispatch } from "react-redux";
import {
  Save_User,
  Save_Games_Data,
  Save_Councils_Data,
  Save_Districts_Data,
  Save_Regions_Data,
} from "../Redux/actions";
import { Link, useNavigate } from "react-router-dom";
import { Field, Formik, Form } from "formik";
import Select from "react-select";
import { toast } from "react-toastify";
import Checkbox from "react-custom-checkbox";
import { BsCheckLg } from "react-icons/bs";
import { useMutation, useQuery } from "react-query";

import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
} from "../Components/Styles/PageStyles";
import {
  SubmitBtn,
  PreviewBtn,
  OtherBtn,
  InputGroup,
  FieldWrapper,
  Label,
  CombineInputGroup,
} from "../Components/Styles/InputStyles";
import { useTranslation } from "react-i18next";
import LoginNavbar from "../Components/LoginNavbar";

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [selectedLang, setActiveLang] = useState("eng");
  // useEffect(() => {
  //   navigate("/");
  // }, []);

  const InitialValue = {
    email: "",
    password: "",
  };

  //------- Send Login Request -------
  const LoginPostFunction = async (values) => {
    const body = new FormData();
    body.append("email", values.email);
    body.append("password", values.password);
    return await axios.post(`${Config.apiUrl}/login`, body, {
      headers: {
        authorization: Config.AxiosConfig.headers.authorization,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onSuccess = (res) => {
    //console.log(res.data);
    if (res?.data?.status == "OK") {
      const expireAt = moment()
        .add(Config.sessionExpiredTime, "minutes")
        .valueOf();
      const realData = { ...res.data.data, expireAt };
      dispatch(Save_User(realData));
      //dispatch(Save_User(res.data.data));
      dispatch(Save_Games_Data(res.data.games));
      if (Config.rdcDataFromBackend == "Yes"){
        dispatch(Save_Councils_Data(res.data.councils));
        dispatch(Save_Districts_Data(res.data.districts));
        dispatch(Save_Regions_Data(res.data.regions));
      }
      navigate("/dashboard");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onError = (res) => {
    //setOpenUploadModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isLoadingReg, mutate: postLogin } = useMutation(
    LoginPostFunction,
    {
      onSuccess: onSuccess,
      onError: onError,
    }
  );
  //------- Send Login Request -------

  const SubmitHandler = (values) => {
    if (!values.email) {
      return toast.error("Please enter email");
    } else if (!values.password) {
      return toast.error("Please enter password");
    }
    postLogin({ ...values });
  };

  const handleLogin = () => {};

  //const changeLang = (lang) => setSelectedLang(lang);

  const languageChangeHandler = (value) => {
    setActiveLang(value);
    i18n.changeLanguage(value);
  };

  return (
    <Login>
      < LoginNavbar />
      {/* <LanguageWrapper>
        <LangButton
          $active={selectedLang === "swahili"}
          onClick={() => languageChangeHandler("swahili")}
        >
          Swahili
        </LangButton>
        <LangButton
          $active={selectedLang === "eng"}
          onClick={() => languageChangeHandler("eng")}
        >
          English
        </LangButton>
      </LanguageWrapper> */}
      {/* <ImageWrapper>
        <LoginImage src={Images.LoginImage2} alt="Login Image" />
      </ImageWrapper> */}
      <TextWrapperComp
        handleLogin={handleLogin}
        InitialValue={InitialValue}
        SubmitHandler={SubmitHandler}
        t={t}
      />
    </Login>
  );
};

const TextWrapperComp = ({ handleLogin, InitialValue, SubmitHandler, t }) => (
  <TextWrapper>
    <Container>
      <Center>
        <div className="flex space-x-6">
          <Logo src={Images.GovtLogo} alt="logo" />
          <VerticalBorder />
          <Logo src={Images.Logo} alt="logo" />
        </div>
        <Title>{t("LoginWelcome")}</Title>
        <SubTitle>{t("please_login")}</SubTitle>
        <Formik
          initialValues={InitialValue}
          onSubmit={SubmitHandler}

          // enableReinitialize={isInitialValueSaved}
        >
          {(formikProps) => (
            <>
              <Form className="w-full">
                <FormContainer>
                  <InputGroup>
                    <Label htmlFor="name">{t("email")}</Label>
                    <FieldWrapper>
                      <Field name="email" id="email" autoComplete="off" />
                    </FieldWrapper>
                  </InputGroup>

                  <InputGroup>
                    <Label htmlFor="password">{t("Password")}</Label>
                    <FieldWrapper>
                      <Field
                        type="password"
                        name="password"
                        id="password"
                        autoComplete="off"
                      />
                    </FieldWrapper>
                  </InputGroup>
                  <RowWrapper>
                    <Checkbox
                      icon={<BsCheckLg className="text-cyan-600 w-2 h-2" />}
                      name="my-input"
                      // checked={isSendLater}
                      onChange={(value) => {
                        // setIsSendLater(value);
                      }}
                      borderColor="#6B7280"
                      style={{ cursor: "pointer" }}
                      labelStyle={{
                        marginLeft: 5,
                        userSelect: "none",
                        color: "#6B7280",
                        fontSize: ".875rem",
                      }}
                      label={t("rememeber")}
                    />
                    <Link to="/forgot-password">
                      <ForgotPassword>{t("ForgotPassword")}</ForgotPassword>
                    </Link>
                  </RowWrapper>
                </FormContainer>

                <div className="mt-12 flex">
                  <SubmitBtn type="submit">{t("login")}</SubmitBtn>

                  {/* <SubmitBtn type="submit" disabled={runCampaignLoading}>
                    {runCampaignLoading && (
                      <Loading
                        color="white"
                        width={20}
                        height={20}
                        noPadding={true}
                      />
                    )}
                    {!runCampaignLoading && "Send"}
                  </SubmitBtn> */}
                </div>
              </Form>
            </>
          )}
        </Formik>
      </Center>

      <Link className="mt-2" to="/register">
        <p className="text-sm text-gray-500 pb-5 ">
          {t("no_account")}{" "}
          <span className="text-cyan-600 font-medium">{t("registar_u")}</span>
        </p>
      </Link>
      {/* <SmallText>
        Virtual health professionals to help with all your rapid testing needs.
      </SmallText> */}
    </Container>
  </TextWrapper>
);


const FormContainer = tw.div` grid max-w-sm  mt-8 w-full gap-5 md:gap-5`;
const Login = tw.section`h-screen flex  bg-white justify-center items-center`;
//const Container = tw.div`pl-10 flex flex-col h-full w-full justify-center overflow-y-auto items-start   `;
const TextWrapper = tw.div`h-full relative p-10`;
const Container = tw.div`flex flex-col h-full w-full justify-center items-start h-auto`;

const Center = tw.div`h-full w-11/12 pt-10 mb-5  flex flex-col   `;

const Logo = tw.img`w-20 h-20 object-contain mb-10`;
//const TextWrapper = tw.div`w-full h-full  md:w-1/2 relative md:overflow-x-hidden overflow-y-auto md:pl-12`;

const TextOverlay = tw.section`absolute -right-40 top-0 h-full  `;

const Title = tw.h1`text-xl sm:text-2xl font-light text-gray-800 tracking-wider`;

const SubTitle = tw.h3`mt-1 sm:mt-2 tracking-wider  text-gray-500 text-sm `;

const Button = tw.button` mt-10 h-20 w-96  md:w-72 lg:w-96 px-5   text-gray-800 flex items-center border rounded-md bg-white z-10 loginBtn  `;

const ImageWrapper = tw.div`hidden h-full  md:block md:w-1/2  `;
const LoginImage = tw.img`h-full w-full object-cover object-center`;



const SmallText = tw.p`text-xs font-normal text-gray-400 `;

const VerticalBorder = tw.div`w-0.5 h-14 bg-gray-300 mt-4`;

const LanguageWrapper = tw.div`absolute top-5 right-5 flex space-x-2.5 items-center z-50`;

const RowWrapper = tw.div`flex space-x-2.5 items-center z-50 mt-4 mb- justify-between w-full`;
const ForgotPassword = tw.h3`tracking-wider  text-cyan-600 text-sm  float-right`;

const LangButton = tw.button`
${(p) =>
  p.$active
    ? "bg-cyan-600 text-white"
    : "hover:bg-gray-300 bg-gray-200 text-gray-800"}
px-4 py-2 text-xs  cursor-pointer  rounded-full `;

export default LoginPage;
